module.exports = new __parcel__URL__("favicon-192.40c8bab4.png").toString();